import { generateColumns } from "../helpers/generateColumns";
import useApi from "./useApiRequest";
import { useMutation, useQuery } from "react-query";

export const GetEntity = () => {
  const api = useApi();

  const mutate = async (param) => {
    const data = await api.get(`/query-builder/all`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getEntityMutation: mutation.mutate,
  };
}

export const GetReportesList = () => {
  const api = useApi();

  const mutate = async (param) => {
    const data = await api.get(`/reportes/all`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getReportesListMutation: mutation.mutate,
  };
}

export const GetReporte = () => {
  const api = useApi();

  const mutate = async (param) => {
    const data = await api.get(`/reportes?repo_id=${param}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getReporteMutation: mutation.mutate,
  };
}

export const CrearReporte = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/reportes`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    crearReporteMutation: mutation.mutate,
  };
}

export const EditarReporte = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.put(`/reportes/${params.id}`, params.body, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    editarReporteMutation: mutation.mutate,
  };
}

export const CopiarReporte = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/reportes/copiar/${params}`, {}, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    copiarReporteMutation: mutation.mutate,
  };
}

export const GetBuildQuery = (id, page = 1, limit = 12) => {
  const api = useApi();
  return useQuery(['buil_query', id, page, limit], async () => {
    const { data } = await api.get(`/query-builder/buil-query/${id}?page=${page}&limit=${limit}`);
    return data;
  }, {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!id,
  });
}

export const DownloadExcel = () => {
  const api = useApi();

  const mutate = async (param) => {
    const data = await api.get(`/query-builder/reporte/export/${param}`, {
      responseType: 'blob', // Indicamos que esperamos un archivo binario (blob)
    });
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    getDownloadExcel: mutation.mutate,
  };
}